import { IPreloadedState } from 'shared/types/redux';

export const selectOffersHistory = (state: IPreloadedState) => state.offersHistory;
